import { gql } from "@apollo/client";
import { ONSEN_URL } from "helpers/environment";
import { gaEvent } from "helpers/gtag";
import React from "react";

import PotwVideoPlayerHeader, { PotwVideoPlayerHeaderFragment } from "./PotwVideoPlayerHeader";
import ReelVideoPlayer from "./ReelVideoPlayer";

export const PotwVideoPlayerFragment = gql`
  fragment PotwVideoPlayerFragment on PotwCompetition {
    name
    videoUrl
    ...PotwVideoPlayerHeaderFragment
  }
  ${PotwVideoPlayerHeaderFragment}
`;

// headerAction: a button at the end of the header, eg the dialog's close; the share page has none
export default function PotwVideoPlayer({ potwCompetition, potwCompetitionId, headerAction }) {
  return (
    <ReelVideoPlayer
      title={potwCompetition?.name}
      header={<PotwVideoPlayerHeader potwCompetition={potwCompetition} action={headerAction} />}
      poster={potwCompetition?.thumbnailUrl}
      videoUrl={potwCompetition?.videoUrl}
      shareUrl={`${ONSEN_URL}/potw/competitions/${potwCompetitionId}/video`}
      sharingDisabled={potwCompetition?.shareable === false}
      onShared={({ share_destination }) => {
        gaEvent("potw_video_share", {
          share_destination,
        });
      }}
      onVideoPlay={() => {
        gaEvent("potw_video_play");
      }}
      onDownload={() => {
        gaEvent("download", { type: "potw_video" });
      }}
    />
  );
}
